import React from 'react'
import PropTypes from 'prop-types'

import { Title, Subtitle, StyledTab, RemoveButton } from './Tab.style'

const Tab = React.forwardRef(
  (
    { title, subtitle, selected, onClick, onRemove, isUndefined, editable },
    ref
  ) => {
    return (
      <StyledTab
        ref={ref}
        onClick={onClick}
        selected={selected}
        isUndefined={isUndefined}
        editable={editable}
      >
        <div>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
        {!isUndefined && editable && <RemoveButton onClick={onRemove} />}
      </StyledTab>
    )
  }
)

Tab.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  isUndefined: PropTypes.bool,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  editable: PropTypes.bool,
}

export default Tab
